import React, { useContext } from 'react';
import { IWatchContext, WatchContext } from '../../Watches/Watches/watchState/watchContext';
import { WatchFullInfoState } from './watchFullInfoState/WatchFullInfoState';
import ModalLayout from 'components/ModalLayout';
import { WatchFullInfoView } from './components/WatchFullInfoView';

export const WatchFullInfoPage: React.FC = () => {
	const { setIDForFullInfo, IDForFullInfo } = useContext<IWatchContext>(WatchContext);

	const handleClose = () => {
		setIDForFullInfo('');
	};

	return (
		<WatchFullInfoState>
			<ModalLayout isVisible={!!IDForFullInfo} setIsShowModal={handleClose}>
				<WatchFullInfoView />
			</ModalLayout>
		</WatchFullInfoState>
	);
};
